import React from 'react';

const BlessingVisual = ({ revealMeta = {} }) => {
  const blessingState = revealMeta.blessingState || {};
  const messages = blessingState.messages?.length ? blessingState.messages : [
    { id: 'waiting', name: 'Guestbook', text: 'Waiting for blessings', placeholder: true },
  ];
  const cards = messages.slice(0, 3);
  while (cards.length < 3) {
    cards.push({ id: `waiting_${cards.length}`, name: 'Guestbook', text: 'Waiting for blessings', placeholder: true });
  }

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-blessing is-${blessingState.style || 'note-cards'}${blessingState.hasMessages ? ' has-messages' : ' is-empty'}`}
      aria-hidden="true"
    >
      {cards.map((message, index) => (
        <span
          key={message.id || index}
          className={`note note-${index}${message.approved ? ' is-approved' : ''}${message.placeholder ? ' is-placeholder' : ''}`}
        >
          <strong>{message.name || 'Guest'}</strong>
          <em>{message.text}</em>
          {message.approved && <small>Approved</small>}
        </span>
      ))}
      <span className="heart" />
    </span>
  );
};

export default BlessingVisual;
